/* Paintly PBN custom variant picker — proxies custom UI to native variant-selects inputs, with linked availability. */
(function(){
  var SQ='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>';
  var POR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="6" y="3" width="12" height="18" rx="2"/></svg>';
  var LAN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="3" y="6" width="18" height="12" rx="2"/></svg>';
  function fire(el){ if(el) el.dispatchEvent(new Event('change',{bubbles:true})); }
  function init(vs){
    var ui = vs.querySelector('.pbnvp'); if(!ui || ui.dataset.wired) return; ui.dataset.wired='1';
    var sizeSel = vs.querySelector('select[name="options[Size]"]');
    var canvasSel = vs.querySelector('select[name="options[Canvas]"]');
    var frameInputs = [].slice.call(vs.querySelectorAll('input[name="Frame"]'));
    var mapEl = ui.querySelector('[data-canvas-map]');
    var map = mapEl ? JSON.parse(mapEl.textContent) : {};
    var variants = [];
    try { variants = JSON.parse(vs.querySelector('script[type="application/json"]').textContent) || []; } catch(e){ variants = []; }
    // option order: 0=Frame, 1=Size, 2=Canvas
    function exists(frame, size, canvas){ // any of args can be null = wildcard; canvas can be a {typePrefix:T} object
      return variants.some(function(v){
        if(!v || !v.options || v.available === false) return false;
        if(frame!=null && v.options[0]!==frame) return false;
        if(size!=null && v.options[1]!==size) return false;
        if(canvas!=null){
          if(canvas.typePrefix!=null){ if((v.options[2].split(' / ')[0])!==canvas.typePrefix) return false; }
          else if(v.options[2]!==canvas) return false;
        }
        return true;
      });
    }
    var dd = ui.querySelector('.pbnvp-dd'), ddbtn = ui.querySelector('.pbnvp-ddbtn');
    if(ddbtn){
      ddbtn.addEventListener('click', function(e){ e.stopPropagation(); dd.classList.toggle('open'); });
      document.addEventListener('click', function(e){ if(!dd.contains(e.target)) dd.classList.remove('open'); });
    }
    function parseCm(str){ var m=String(str||'').match(/(\d+)\s*x\s*(\d+)/i); return m?{w:+m[1],h:+m[2]}:null; }
    function orientOf(str){ var d=parseCm(str); if(!d) return null; return d.w===d.h?'Square':(d.w>d.h?'Landscape':'Portrait'); }
    var hasShapes = !!ui.querySelector('.pbnvp-shapes');
    /* sort size rows smallest -> biggest (by cm area) */
    var panel = ui.querySelector('.pbnvp-ddpanel');
    if(panel){
      var rowsAll = [].slice.call(panel.querySelectorAll('.pbnvp-ddrow'));
      rowsAll.sort(function(a,b){
        function area(r){ var da=+r.getAttribute('data-area'); if(da) return da; var d=parseCm(r.getAttribute('data-size')); return d?d.w*d.h:0; }
        function wid(r){ var d=parseCm(r.getAttribute('data-size')); return d?d.w:0; }
        return (area(a)-area(b)) || (wid(a)-wid(b));
      });
      rowsAll.forEach(function(r){ panel.appendChild(r); });
    }
    function curType(){ return canvasSel ? (canvasSel.value.split(' / ')[0]||'').trim() : ''; }
    function curCount(){ return canvasSel ? (((canvasSel.value.split(' / ')[1]||'').trim().split(' ')[0])||'') : ''; }
    function curFrame(){ var r=frameInputs.filter(function(x){return x.checked;})[0]; return r?r.value:null; }
    function setCanvas(tp,cn){ var v=map[tp+'|'+cn]; if(v && canvasSel){ canvasSel.value=v; fire(canvasSel); } }
    ui.addEventListener('click', function(e){
      var el=e.target.closest('.pbnvp-soldout'); if(el) return; // ignore unavailable
      var f=e.target.closest('[data-frame]');
      if(f){ frameInputs.forEach(function(r){ if(r.value===f.getAttribute('data-frame') && !r.checked){ r.checked=true; fire(r); } }); return; }
      var row=e.target.closest('[data-size]');
      if(row){ if(sizeSel){ sizeSel.value=row.getAttribute('data-size'); fire(sizeSel); } if(dd) dd.classList.remove('open'); return; }
      var sh=e.target.closest('[data-shape]');
      if(sh){
        var S=sh.getAttribute('data-shape');
        var cur=sizeSel?sizeSel.value:null;
        if(!sizeSel || orientOf(cur)===S) return;
        var pick=null, d=parseCm(cur);
        if(d){ /* prefer the mirrored size, e.g. 50x40 <-> 40x50 */
          var mir=d.h+'x'+d.w+'cm';
          if(orientOf(mir)===S){
            var mr=null; ui.querySelectorAll('[data-size]').forEach(function(r){ if(r.getAttribute('data-size')===mir) mr=r; });
            if(mr && !mr.classList.contains('pbnvp-soldout')) pick=mir;
          }
        }
        if(!pick){
          var match=[].slice.call(ui.querySelectorAll('[data-size]')).filter(function(r){ return orientOf(r.getAttribute('data-size'))===S; });
          var avail=match.filter(function(r){ return !r.classList.contains('pbnvp-soldout'); });
          var rp=avail[0]||match[0];
          if(rp) pick=rp.getAttribute('data-size');
        }
        if(pick){ sizeSel.value=pick; fire(sizeSel); }
        return;
      }
      var t=e.target.closest('[data-ct]'); if(t){ setCanvas(t.getAttribute('data-ct'), curCount()); return; }
      var c=e.target.closest('[data-cc]'); if(c){ setCanvas(curType(), c.getAttribute('data-cc')); return; }
    });
    function sync(){
      var cf=curFrame(), cs=sizeSel?sizeSel.value:null, cc=canvasSel?canvasSel.value:null, tp=curType(), cn=curCount();
      // FRAME: available if a variant exists for this frame + current size + current canvas
      ui.querySelectorAll('[data-frame]').forEach(function(b){
        var F=b.getAttribute('data-frame');
        b.setAttribute('aria-pressed', F===cf);
        b.classList.toggle('pbnvp-soldout', !exists(F, cs, cc));
      });
      // SIZE: available if a variant exists for current frame + current canvas + this size
      ui.querySelectorAll('[data-size]').forEach(function(r){
        var S=r.getAttribute('data-size');
        r.setAttribute('aria-pressed', S===cs);
        r.classList.toggle('pbnvp-soldout', !exists(cf, S, cc));
      });
      var curOri = cs ? orientOf(cs) : null;
      if(hasShapes){
        ui.querySelectorAll('.pbnvp-shape').forEach(function(b){
          var S=b.getAttribute('data-shape');
          b.setAttribute('aria-pressed', S===curOri);
          var any=false;
          ui.querySelectorAll('[data-size]').forEach(function(r){ if(orientOf(r.getAttribute('data-size'))===S && !r.classList.contains('pbnvp-soldout')) any=true; });
          b.classList.toggle('pbnvp-soldout', !any);
        });
        ui.querySelectorAll('[data-size]').forEach(function(r){
          r.classList.toggle('pbnvp-hide', !!curOri && orientOf(r.getAttribute('data-size'))!==curOri);
        });
      }
      if(ddbtn){
        var sr=null; ui.querySelectorAll('[data-size]').forEach(function(r){ if(r.getAttribute('data-size')===cs) sr=r; });
        if(sr){ var ori=sr.getAttribute('data-orient'); ddbtn.querySelector('.pbnvp-ddlabel').innerHTML='<span class="pbnvp-badge '+(ori==='Square'?'sq':(ori==='Landscape'?'lan':'por'))+'">'+(ori==='Square'?SQ:(ori==='Landscape'?LAN:POR))+ori+'</span><span><span class="pbnvp-cmv">'+sr.getAttribute('data-cm')+'</span> <span class="pbnvp-inv">'+sr.getAttribute('data-in')+'</span></span>'; }
      }
      // CANVAS TYPE: available if a variant exists for current frame + size + this type (any count)
      ui.querySelectorAll('[data-ct]').forEach(function(b){
        var T=b.getAttribute('data-ct');
        b.setAttribute('aria-pressed', T===tp);
        b.classList.toggle('pbnvp-soldout', !exists(cf, cs, {typePrefix:T}));
      });
      // DETAIL (count): available if a variant exists for current frame + size + (current type / this count)
      ui.querySelectorAll('[data-cc]').forEach(function(b){
        var C=b.getAttribute('data-cc');
        b.setAttribute('aria-pressed', C===cn);
        b.classList.toggle('pbnvp-soldout', !exists(cf, cs, map[tp+'|'+C]));
      });
    }
    vs.addEventListener('change', sync);
    sync();
    /* >250-variant top-up: Liquid caps product.variants at 250 per render, so the
       inline JSON misses variants 251+ and their sizes grey out as "sold out".
       Fetch the remaining pages via the Section Rendering API
       (sections/paintly-variants-json.liquid — same pattern as the AI forms),
       merge into the availability map AND the native inline JSON, then re-sync. */
    (function(){
      if(variants.length < 250) return;
      var invScript = vs.querySelector('script[type="application/json"]');
      var seen = {};
      variants.forEach(function(v){ if(v && v.id != null) seen[String(v.id)] = 1; });
      var base = vs.getAttribute('data-url') || window.location.pathname;
      function page(p){
        return fetch(base + '?section_id=paintly-variants-json&page=' + p, {credentials:'same-origin'})
          .then(function(r){ return r.text(); })
          .then(function(t){
            var m = t.match(/id="paintly-variants-page"[^>]*>([\s\S]*?)<\/script>/);
            if(!m) return null;
            var data = JSON.parse(m[1]);
            (data.variants || []).forEach(function(vv){
              if(seen[String(vv.id)]) return;
              seen[String(vv.id)] = 1;
              variants.push({
                id: vv.id, title: vv.title, options: vv.options,
                option1: vv.options[0] || null, option2: vv.options[1] || null, option3: vv.options[2] || null,
                available: vv.available,
                price: (vv.price_cents != null ? vv.price_cents : vv.price),
                compare_at_price: (vv.compare_at_price_cents != null ? vv.compare_at_price_cents : null),
                featured_image: null, name: vv.title, public_title: vv.title, sku: null,
                requires_selling_plan: false, selling_plan_allocations: [],
                quantity_rule: {min: 1, max: null, increment: 1}
              });
            });
            return data;
          });
      }
      function loop(p){ return page(p).then(function(d){ if(d && d.page < d.pages) return loop(p + 1); }); }
      loop(2).then(function(){
        if(invScript){ try{ invScript.textContent = JSON.stringify(variants); }catch(e){} }
        sync();
      }, function(){ /* keep first 250 on failure */ });
    })();
  }
  function boot(){ document.querySelectorAll('variant-selects.pbnvp-host').forEach(init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
